<div class="associations">
    <div class="container">
        <div class="associations-logo">
            <div>
                <img src="assets/handicap-International.png" alt="logo-handicap-international">
            </div>
            <div>
                <img src="assets/habitat-humanisme.png" alt="logo-habitat-humanisme">
            </div>
            <div>
                <img src="assets/entourage-1.png" alt="logo-entourage">
            </div>
            <div>
                <img src="assets/foyer-sans-abris.png" alt="logo-foyer-sans-abris">
            </div>
        </div>
    </div>
</div>
